import http from "../http-common";

class OrganigramaDataService {
  getAll() {
    return http.get("/organigrama");
  }

  getOrganigramaByDescr(condition, sortfield, sorttype) {
    return http.get(`/organigrama/search/?nombreorganigrama=${condition}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  get(id) {
    return http.get(`/organigrama/${id}`);
  }

  duplicate(id) {
    return http.post(`/organigrama/duplicate/${id}`);
  }

  create(data) {
    return http.post("/organigrama/neworganigrama", data);
  }

  update(id, data) {
    return http.put(`/organigrama/${id}`, data);
  }

  delete(id) {
    return http.delete(`/organigrama/${id}`);
  }

  deleteAll() {
    return http.delete(`/organigrama`);
  }

  /*
  findById(id) {
    return http.get(`/organigrama?id=${id}`);
  }
  */
}

export default new OrganigramaDataService();